module.exports = __webpack_public_path__ + "img/done-btn.bbd9649a.svg";